import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Mimadre from './Mimadre';
import Eos from './Eos';
import Gaia from './Gaia';
import AnimacionLectora from './AnimacionLectora';
import ClubLectura from './ClubLectura';
import FirmasFerias from './FirmasFerias';
import NotFound from './components/NotFound';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/mimadre" element={<Mimadre />} />
        <Route path="/eos" element={<Eos />} />
        <Route path="/gaia" element={<Gaia />} />
        <Route path="/animacion-lectora" element={<AnimacionLectora />} />
        <Route path="/club-lectura" element={<ClubLectura />} />
        <Route path="/firmas-y-ferias" element={<FirmasFerias />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();